import { render, staticRenderFns } from "./MenuTopPortrait.vue?vue&type=template&id=96b2366e"
import script from "./MenuTopPortrait.vue?vue&type=script&lang=js"
export * from "./MenuTopPortrait.vue?vue&type=script&lang=js"
import style0 from "./MenuTopPortrait.vue?vue&type=style&index=0&id=96b2366e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports